var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.reports && _vm.reports.length > 0)?_c('div',{staticClass:"card-list__items"},_vm._l((_vm.reports),function(report){return _c('report',{key:report.id,attrs:{"report":report,"current-user-id":_vm.currentUserId,"display-user-icon":_vm.displayUserIcon}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }